import { Box, Button, Typography } from '@mui/material';
import likeIcon from '../../../assets/TeaAndSnacks/yes.png';
import dislikeIcon from '../../../assets/TeaAndSnacks/no.png';
import { useAddVoteMutation, useGetVoteQuery } from '../teaAndSnacksApiSlice';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../Auth/authSlice';
import useInitializeSocket from '../../../hooks/sockets/useInitializeSocket';
import { useEffect, useState } from 'react';
export const UserOptionCard = ({ snacksData, setSnacksVoteData, configData, locationName, setIsLoading }) => {
  const socket = useInitializeSocket();
  const [addVote] = useAddVoteMutation();
  const user = useSelector(selectCurrentUser);
  const currentDate = new Date(new Date().toDateString()).getTime();
  const [isVoteClosed, setIsVoteClosed] = useState(false);
  const [isVoteAddLoading, setVoteAddLoading] = useState(false);
  const {
    data: snacksVote,
    isLoading: snacksVoteLoading,
    isError: snacksVoteError,
    refetch: snacksVoteDataRefetch,
  } = useGetVoteQuery({ date: currentDate, region: locationName, empId: user?.empId }, { skip: !locationName });
  useEffect(() => {
    if (configData?.voteEndTime) {
      const { hours, minutes } = configData.voteEndTime;
      const voteEnd = new Date();
      voteEnd.setHours(hours);
      voteEnd.setMinutes(minutes);
      voteEnd.setSeconds(0);
      voteEnd.setMilliseconds(0);

      const checkVoteTime = () => {
        const now = new Date();
        setIsVoteClosed(now > voteEnd);

        if (!isVoteAddLoading) {
          if (
            now > voteEnd &&
            (snacksVote?.message === 'No vote for this employee' || snacksVote?.data == null) &&
            !snacksVoteLoading
          ) {
            handleVote(false);
          }
        }
      };

      checkVoteTime(); // initial check
      const interval = setInterval(checkVoteTime, 30000);
      return () => clearInterval(interval);
    }
  }, [configData, snacksVote, snacksVoteLoading]);
  const handleVote = async (vote) => {
    if (isVoteAddLoading) return;
    try {
      setIsLoading(true);
      setVoteAddLoading(true);

      let params = {
        date: currentDate,
        empId: user.empId,
        name: user.username,
        vote: vote,
        region: locationName,
        socketId: socket.id,
      };

      const res = await addVote(params);      
      if (res?.data?.message === 'Vote recorded successfully') {
        const userVote = res?.data?.data?.votes?.find((v) => v.empId === user.empId);
        setVoteAddLoading(false);
        setSnacksVoteData(userVote);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  socket.on('vote-updated', (response) => {
    setSnacksVoteData(response);
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '5px' }}>
      {snacksData?.snack ? (
        <>
          <Typography sx={{ color: '#0A4FAC', fontWeight: 'bold', fontSize: '90%' }}>
            Do you want snacks today ?
          </Typography>
          <Typography sx={{ color: '#808080', fontWeight: 'bold', fontSize: '90%' }}>{snacksData.snack}</Typography>
        </>
      ) : (
        <Typography sx={{ color: '#808080', fontWeight: 'bold' }}>
          {!isVoteClosed && 'Kindly wait for the snacks are still not added by the vendor for today'}
        </Typography>
      )}

      <Box sx={{ display: 'flex', gap: 7, justifyContent: 'center' }}>
        <Button
          disabled={!snacksData || isVoteClosed}
          onClick={() => handleVote(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            opacity: !snacksData || isVoteClosed ? 0.6 : 1,
          }}
        >
          <img src={likeIcon} width="30%" />
        </Button>
        <Button
          disabled={!snacksData || isVoteClosed}
          onClick={() => handleVote(false)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            opacity: !snacksData || isVoteClosed ? 0.6 : 1,
          }}
        >
          <img src={dislikeIcon} width={'40%'} />
        </Button>
      </Box>
      {isVoteClosed ? (
        <Typography sx={{ color: '#808080', fontWeight: 'bold' }}>Vote Closed</Typography>
      ) : (
        snacksData && (
          <Typography sx={{ color: '#808080', fontSize: '90%' }}>
            Kindly select your vote before{' '}
            {configData?.voteEndTime
              ? new Date(0, 0, 0, configData.voteEndTime.hours, configData.voteEndTime.minutes).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
                })
              : '--:--'}{' '}
            else it will be disabled
          </Typography>
        )
      )}
    </Box>
  );
};
